/* eslint id-length: [2, {"exceptions":["a","b"]}] */

import { kffNumericValue, kffIsNumber } from '../util';
import { sortArbitrary, buildRowProperties } from './util';
import { appDefault as constants } from '../../config/config';

export default function numberSort(a, b, column, isInverted, aBase, bBase) {
  let aNumber = kffNumericValue(a);
  let bNumber = kffNumericValue(b);
  const aNotAvailable = constants.dataNotAvailable.indexOf(a) !== -1;
  const bNotAvailable = constants.dataNotAvailable.indexOf(b) !== -1;
  // KFF-2244 If we do not check for null, +null will equal 0 lower
  // lower in the function, causing an improper sort
  const aInvalid = isNaN(aNumber) || aNumber === null || aNotAvailable;
  const bInvalid = isNaN(bNumber) || bNumber === null || bNotAvailable;
  const aProps = buildRowProperties(a, column, constants);
  const bProps = buildRowProperties(b, column, constants);

  // NAs pushed to the bottom
  if (aProps.naData && bProps.naData) {
    const sorted = sortArbitrary(
      aProps.value,
      bProps.value,
      constants.dataNotAvailable,
      isInverted
    );
    if (sorted) {
      return sorted;
    }
  } else if (aProps.naData) {
    return (isInverted ? -1 : 1);
  } else if (bProps.naData) {
    return (isInverted ? 1 : -1);
  }

  if (aInvalid && bInvalid) {
    return (isInverted ? 1 : -1) * a.localeCompare(b);
  } else if (aInvalid) {
    return (isInverted ? -1 : 1) * 1;
  } else if (bInvalid) {
    return (isInverted ? -1 : 1) * -1;
  }

  if (!kffIsNumber(a) &&
      /<|>/g.test(a) && aNumber === bNumber) {
    aNumber = />/g.test(a) ? ++aNumber : aNumber;
    aNumber = /</g.test(a) ? --aNumber : aNumber;
  } else if (!kffIsNumber(b) &&
      /<|>/g.test(b) && bNumber === aNumber) {
    bNumber = />/g.test(b) ? ++bNumber : bNumber;
    bNumber = /</g.test(b) ? --bNumber : bNumber;
  }

  if (+aNumber === +bNumber) {
    return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
  }

  return +aNumber - +bNumber;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/sorters/numberSort.js